export default __webpack_public_path__ + "85b47d4e8528f8a85e900fb6f083e611.svg";